import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover'; // shadcn popover
import { Calendar } from '@/components/ui/calendar'; // shadcn calendar
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';
import { cn } from '@/lib/utils';

// Define the type for the field prop
interface CalendarDatePickerProps {
  field: {
    value: Date | null;
    onChange: (date: Date | null) => void;
  };
  className?: string;
  calendarClassName?: string;
}

export const CalendarDatePicker = ({ 
  field, 
  className,
  calendarClassName 
}: CalendarDatePickerProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-full justify-start text-left font-normal",
            !field.value && "text-muted-foreground",
            className
          )}
        >
          {field.value ? format(field.value, 'PPP') : 'Pick a date'}
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn("w-auto p-0", calendarClassName)} align="start">
        <Calendar
          mode="single"
          selected={field.value ?? undefined}
          onSelect={(date: Date | undefined) => field.onChange(date ?? null)}
          // disabled={(date: Date) => date < new Date('1900-01-01') || date > new Date()} // Correctly typed 'date'
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
